import { motion, type MotionProps } from 'framer-motion'
import type { ReactNode } from 'react'
import { cn } from '../../lib/cn'

type FadeInProps = {
  children: ReactNode
  className?: string
  delay?: number
  y?: number
  once?: boolean
  amount?: number
} & MotionProps

export function FadeIn({
  children,
  className,
  delay = 0,
  y = 16,
  once = true,
  amount = 0.25,
  ...rest
}: FadeInProps) {
  return (
    <motion.div
      className={cn(className)}
      initial={{ opacity: 0, y, filter: 'blur(8px)' }}
      whileInView={{ opacity: 1, y: 0, filter: 'blur(0px)' }}
      transition={{ duration: 0.7, ease: [0.21, 0.75, 0.2, 1], delay }}
      viewport={{ once, amount }}
      {...rest}
    >
      {children}
    </motion.div>
  )
}


